import { COLORS } from "../../assets/theme";

// Shared look for the All Data side menu so it matches the venue dashboard's
// sidebar (active bar, hover tint, icon nudge). Each All Data page still owns
// its own navigation logic.

// MainLayout leaves a gap under its header; pull the page up into it so the
// side menu runs flush from the header to the bottom like the dashboard's.
export const adminPageSx = {
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  display: "flex",
  bgcolor: COLORS.MainBackground,
  mt: { xs: -1, sm: -2 },
  minHeight: { xs: "calc(100vh - 48px)", sm: "calc(100vh - 64px)" },
};

export const adminNavPanelSx = (collapsed: boolean) => ({
  width: collapsed ? 72 : 240,
  flexShrink: 0,
  borderRight: "1px solid",
  borderColor: "divider",
  bgcolor: COLORS.WhiteBackground,
  py: 2,
  px: collapsed ? 1 : 1.5,
  transition: "width 0.2s ease",
  display: "flex",
  flexDirection: "column",
  gap: 1,
});

export const adminNavTitleSx = {
  color: COLORS.MainColor,
  fontWeight: 700,
  fontSize: "1.1rem",
};

export const adminNavItemSx = (selected: boolean, collapsed: boolean) => ({
  mb: 0.5,
  borderRadius: 2,
  minHeight: 40,
  px: collapsed ? 1.4 : 1.75,
  justifyContent: collapsed ? "center" : "flex-start",
  position: "relative",
  color: selected ? COLORS.SidebarActiveText : COLORS.SidebarInactiveText,
  bgcolor: selected ? COLORS.SidebarActiveBg : "transparent",
  transition: "all 0.2s",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: "22%",
    bottom: "22%",
    width: 3,
    borderRadius: 3,
    bgcolor: COLORS.SidebarActiveText,
    transform: selected ? "scaleY(1)" : "scaleY(0)",
    transition: "transform 0.25s cubic-bezier(0.2, 0, 0, 1)",
  },
  "&:hover": {
    bgcolor: selected ? COLORS.SidebarActiveBg : "rgba(0, 0, 0, 0.04)",
  },
  "&.Mui-selected, &.Mui-selected:hover": {
    bgcolor: COLORS.SidebarActiveBg,
  },
  "& .MuiListItemIcon-root .MuiSvgIcon-root": {
    fontSize: "1.2rem",
    transition: "transform 0.2s",
  },
  "&:hover .MuiListItemIcon-root .MuiSvgIcon-root": {
    transform: "translateX(2px)",
  },
});

export const ADMIN_DATA_SUBTITLES: Record<string, string> = {
  clients: "Clients across all your venues.",
  finance: "Invoices across all your venues.",
  expenses: "Expenses across all your venues.",
  reports: "Financial reports across all your venues.",
  notifications: "Devices registered for push notifications.",
};
